import script from "./OrderOutOfStockLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderOutOfStockLog.vue?vue&type=script&setup=true&lang=ts"

import "./OrderOutOfStockLog.vue?vue&type=style&index=0&id=687a200a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-687a200a"]])

export default __exports__